import { promiseState } from "../../helper"
import { video } from "../actions/types"
const { pendingState, fulfilledState, rejectedState } = promiseState

const initialState = {
	isLoading: false,
	message: null,
	errors: [],
	data: [],
	page: {
		totalPage: 0,
		currentPage: 1,
		totalData: 0,
	},

	detail: {},

	streamingResource: {},
	specialGuest: {},
}

const videoReducer = (state = initialState, action) => {
	switch (action.type) {
		case pendingState(video.GET_VIDEO): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(video.GET_VIDEO): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(video.GET_VIDEO): {
			return Object.assign({}, state, {
				isLoading: false,
				data: action.payload.data.data,
				page: {
					totalPage: action.payload.data.page.totalPage,
					currentPage: action.payload.data.page.currentPage,
					totalData: action.payload.data.page.totalData,
				},
			})
		}

		case pendingState(video.GET_VIDEO_DETAIL): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(video.GET_VIDEO_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(video.GET_VIDEO_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
				detail: action.payload.data.data,
			})
		}

		case pendingState(video.GET_STREAMING_VIDEO): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(video.GET_STREAMING_VIDEO): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(video.GET_STREAMING_VIDEO): {
			return Object.assign({}, state, {
				isLoading: false,
				streamingResource: action.payload.data.data,
			})
		}

		case pendingState(video.GET_SPECIAL_GUEST): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(video.GET_SPECIAL_GUEST): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(video.GET_SPECIAL_GUEST): {
			return Object.assign({}, state, {
				isLoading: false,
				specialGuest: action.payload.data.data,
			})
		}

		case pendingState(video.ADD_VIDEO): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(video.ADD_VIDEO): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(video.ADD_VIDEO): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		default:
			return state
	}
}

export default videoReducer
